import { render, staticRenderFns } from "./EditarPersona.vue?vue&type=template&id=ca2b7b2a&"
import script from "./EditarPersona.vue?vue&type=script&lang=js&"
export * from "./EditarPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports